/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationAnalyticsShow } from '../../axios/organisationAnalyticsShow'
import type {
	OrganisationAnalyticsShowError,
	OrganisationAnalyticsShowQueryParams,
	OrganisationAnalyticsShowResponse,
} from '../../types/OrganisationAnalyticsShow'

export const organisationAnalyticsShowQueryKey = (params?: OrganisationAnalyticsShowQueryParams) =>
	[{ url: '/analytics/overview' }, ...(params ? [params] : [])] as const

export type OrganisationAnalyticsShowQueryKey = ReturnType<typeof organisationAnalyticsShowQueryKey>

/** @see backend/nexus/modules/Analytics/Http/Controllers/OrganisationAnalyticsController.php OrganisationAnalyticsController::show */
export function organisationAnalyticsShowQueryOptions(
	params?: OrganisationAnalyticsShowQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		OrganisationAnalyticsShowResponse,
		AxiosError<OrganisationAnalyticsShowError>,
		OrganisationAnalyticsShowResponse,
		OrganisationAnalyticsShowQueryKey
	>({
		queryKey: organisationAnalyticsShowQueryKey(params),
		queryFn: ({ signal }) => organisationAnalyticsShow(params, { signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/Analytics/Http/Controllers/OrganisationAnalyticsController.php OrganisationAnalyticsController::show */
export function useOrganisationAnalyticsShow<TSelectData = OrganisationAnalyticsShowResponse>(
	params?: OrganisationAnalyticsShowQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					OrganisationAnalyticsShowResponse,
					AxiosError<OrganisationAnalyticsShowError>,
					TSelectData,
					OrganisationAnalyticsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<OrganisationAnalyticsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...organisationAnalyticsShowQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Analytics/Http/Controllers/OrganisationAnalyticsController.php OrganisationAnalyticsController::show */
export function useOrganisationAnalyticsShowSuspense<TSelectData = OrganisationAnalyticsShowResponse>(
	params?: OrganisationAnalyticsShowQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					OrganisationAnalyticsShowResponse,
					AxiosError<OrganisationAnalyticsShowError>,
					TSelectData,
					OrganisationAnalyticsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<OrganisationAnalyticsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...organisationAnalyticsShowQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
